import {Grid, getValueByDevice, useDevice, VStack} from 'platform/foundation';

import {SkeletonLoadingBox} from '@dms/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

const SKELETON_BACKGROUND_COLOR = 'palettes.neutral.30.100' as const;
const SKELETON_SECTIONS = ['first', 'second'] as const;
const FEATURES = [
  {key: 'first', width: 36},
  {key: 'second', width: 28},
  {key: 'third', width: 44},
  {key: 'fourth', width: 32},
  {key: 'fifth', width: 40},
  {key: 'sixth', width: 24},
  {key: 'seventh', width: 36},
  {key: 'eighth', width: 30},
  {key: 'ninth', width: 26},
] as const;

export function FeaturesDetailSkeleton(props: TestIdProps) {
  const device = useDevice();

  return (
    <VStack spacing={6} data-testid={suffixTestId('skeleton', props)}>
      <SkeletonLoadingBox isLoading height={3} backgroundColor={SKELETON_BACKGROUND_COLOR} />
      {SKELETON_SECTIONS.map((section) => (
        <VStack key={section} spacing={4}>
          <SkeletonLoadingBox
            isLoading
            width={40}
            height={5}
            backgroundColor={SKELETON_BACKGROUND_COLOR}
          />
          <Grid columns={getValueByDevice(device, 1, 1, 2, 3, 3)} spacing={3}>
            {FEATURES.map((feature) => (
              <SkeletonLoadingBox
                key={feature.key}
                isLoading
                width={feature.width}
                height={4}
                backgroundColor={SKELETON_BACKGROUND_COLOR}
              />
            ))}
          </Grid>
        </VStack>
      ))}
    </VStack>
  );
}
